import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { deleteRule, saveRule } from "../ruleService";
import { connect } from "react-redux";
import { showInfoToast, showSuccessToast, showWarningToast } from "../../validation/ToastContainer";
import * as ruleService from "../ruleService";
import * as storeService from "./addRuleStoreService";
import { PopupContext } from "../../index";
import { getConfirmPopup, getDeletePopup, POPUP_TYPES } from "../../view/popup/PopupContainer";
import { X, RotateCcw, Save, Trash2 } from "lucide-react";
import { canEditRuleFields, isAdminUser } from "./rulePermissions";

function PageHeader({ rule, auth }) {

    const history = useHistory();
    const { setPopup } = useContext(PopupContext);
    const disabled = rule.baseRule === true || !canEditRuleFields(auth);
    const canDelete = !disabled && isAdminUser(auth);

    const onSaveClick = () => {
        if (!isAdminUser(auth)) {
            showWarningToast('You are not authorized to edit this rule', 'Save');
            return;
        }

        if (!rule.name || !rule.version || !rule.details) {
            showWarningToast('Fields must not be empty', 'Save');
            return;
        }
        if (rule.msbList.length === 0) {
            showWarningToast('Please Select MSB!', 'Save');
            return;
        }

        if (rule.pk) {
            setPopup(
                getConfirmPopup(
                    'Are you sure?',
                    'Save',
                    () => saveRule(rule)
                        .then(() => showSuccessToast('Rule saved', 'Save'))
                        .then(() => history.push('/msb'))
                )
            )
        }
        else {
            setPopup(
                {
                    type: POPUP_TYPES.SAVE_RULE_POPUP,
                    ruleData: rule,
                    confirm: () => saveRule(rule)
                        .then(() => showSuccessToast('Rule saved', 'Save'))
                        .then(() => history.push('/msb'))
                }
            )
        }


    }

    const onRevertClick = () => {
        setPopup(
            getConfirmPopup(
                'Are you sure?',
                'Revert changes',
                () => {
                    if (rule.id) {
                        ruleService.getById(rule.id).then(() => storeService.changeLastRuleLoad());
                    } else {
                        storeService.revertRule();
                        storeService.changeLastRuleLoad();
                    }
                    showInfoToast('Rule reverted', 'Revert')
                }
            )
        )
    }

    const onDeleteClick = () => {
        setPopup(
            getDeletePopup('Are you sure you want to delete this rule?',
                'Delete Rule',
                () => deleteRule(rule.id)
                    .then(success => success && showSuccessToast('Rule deleted', 'Delete'))
                    .then(() => history.push('/msb')),
                undefined,
                'Delete Rule'
            )
        )
    }

    return (
        <>
            {/* Cancel */}
            <button
                className="addrules-btn-outline-v2"
                // onClick={() => history.push('/msb')}
                onClick={() => history.goBack()}
            >
                <X />
                Cancel
            </button>

            {/* Revert */}
            <button
                onClick={disabled ? null : () => onRevertClick()}
                className={`addrules-btn-outline-v2 ${disabled ? 'disabled' : ''}`}
            >
                <RotateCcw />
                Revert
            </button>

            {/* Delete — only on existing rules */}
            {rule.id &&
                <button
                    onClick={canDelete ? () => onDeleteClick() : null}
                    className={`addrules-btn-delete-v2 ${canDelete ? '' : 'disabled'}`}
                >
                    <Trash2 />
                    Delete
                </button>
            }

            {/* Save */}
            <button
                onClick={disabled ? null : () => onSaveClick()}
                className={`addrules-btn-save-v2 ${disabled ? 'disabled' : ''}`}
            >
                <Save />
                Save
            </button>
        </>
    )

}

function mapStateToProps(state) {
    const addRulesPage = state.addRulesPage;
    const auth = state.auth;
    return {
        rule: addRulesPage.rule,
        auth,
    }
}

export default connect(mapStateToProps)(PageHeader);
